import { useEffect } from 'react';
import { useAppDispatch } from '../store';
import { loadAllFunds } from '../store/slices/funds.slice';
export default function useAllDexfunds() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(loadAllFunds());
    }, []);
}
